export { default } from './FeaturedWork';
